import script from "./VSwitchLang.vue?vue&type=script&setup=true&lang=js"
export * from "./VSwitchLang.vue?vue&type=script&setup=true&lang=js"

import "./VSwitchLang.vue?vue&type=style&index=0&id=2b085634&scoped=true&lang=css"

import exportComponent from "/var/www/html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b085634"]])

export default __exports__